import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetFirefoxIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 13,
			fill: "#1E1239"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9898 14.7039C32.3808 13.2387 31.1465 11.6567 30.1782 11.1562C30.9669 12.702 31.423 14.2536 31.5974 15.4109C31.5974 15.4074 31.5986 15.4138 31.5998 15.4237L31.6021 15.4389C32.925 19.0245 32.2041 22.6708 31.1658 24.899C29.5593 28.3464 25.671 31.8795 19.583 31.7063C13.0056 31.5208 7.21095 26.6414 6.12949 20.2483C5.93234 19.2403 6.12949 18.7288 6.22866 17.9104C6.10791 18.5404 6.06183 18.7235 6.00117 19.8441L6 19.9158C6 27.6563 12.2764 33.9327 20.0181 33.9327C26.9519 33.9327 32.7086 28.8988 33.8368 22.2881L33.9009 21.7474C34.1792 19.3442 33.87 16.8167 32.991 14.7039H32.9898Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0456 17.2202C20.0222 17.569 18.7914 18.7718 18.3598 18.7718C14.3735 18.7718 13.7266 21.1826 13.7266 21.1826C13.9033 23.2125 15.3167 24.8854 17.0281 25.7703C17.1063 25.8111 17.1856 25.8461 17.2643 25.8829C17.4 25.943 17.5373 25.9992 17.6762 26.0515C18.2632 26.2593 18.878 26.3778 19.5002 26.4032C26.4871 26.731 27.8415 18.0502 22.7988 15.5303C24.0897 15.3057 25.4295 15.8249 26.1785 16.351C24.9535 14.2091 22.664 12.7637 20.0362 12.7637C19.87 12.7637 19.7072 12.7777 19.5439 12.7888C18.1377 12.8855 16.7933 13.4036 15.6859 14.2756C15.8994 14.4564 16.1409 14.6979 16.6484 15.199C17.5992 16.1358 20.0392 17.1064 20.0444 17.2202H20.0456Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9898 14.7034C32.3808 13.2382 31.1465 11.6562 30.1782 11.1558C30.9669 12.7015 31.423 14.2531 31.5974 15.4104L31.6003 15.4337C30.0149 11.483 27.3276 9.88939 25.1326 6.42045L24.8024 5.8838C24.7472 5.78917 24.6957 5.69246 24.6479 5.5939C24.5568 5.41795 24.4865 5.23198 24.4385 5.03975C24.4388 5.03056 24.4357 5.02157 24.4298 5.01455C24.4238 5.00753 24.4155 5.003 24.4064 5.00184C24.3978 4.99939 24.3887 4.99939 24.3801 5.00184L24.3731 5.00592L24.3632 5.01175L24.369 5.00359C20.8476 7.06617 19.653 10.881 19.5427 12.7908C18.1366 12.8873 16.7922 13.4053 15.6847 14.277C15.5689 14.1791 15.4477 14.0876 15.3219 14.0029C15.0023 12.8851 14.9886 11.702 15.2822 10.5771C13.8426 11.2328 12.7215 12.2687 11.9078 13.1845H11.9019C11.346 12.481 11.3851 10.1589 11.4166 9.67415C11.4108 9.64382 11.0025 9.88589 10.9488 9.92205C10.4583 10.2721 9.99983 10.6648 9.57861 11.0957C9.0994 11.5818 8.66157 12.107 8.26966 12.6659L8.26908 12.6677V12.6659C7.36763 13.9433 6.72825 15.3866 6.3879 16.9124L6.36924 17.0058C6.31758 17.2965 6.27149 17.5882 6.23099 17.8807L6.22807 17.9111C6.10529 18.5494 6.02926 19.1959 6.00058 19.8453L6 19.9153C6 27.6558 12.2764 33.9322 20.0181 33.9322C26.9519 33.9322 32.7086 28.8983 33.8368 22.2876L33.9009 21.7469C34.1792 19.3437 33.87 16.8162 32.991 14.7034H32.9898ZM16.8321 25.6755C16.898 25.7064 16.9604 25.7408 17.0269 25.7712L17.0362 25.777C16.9677 25.7442 16.8996 25.7104 16.8321 25.6755ZM31.6009 15.4367L31.5992 15.4232L31.6015 15.4384L31.6009 15.4367Z",
			fill: "url(#paint0_linear_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9898 14.7039C32.3808 13.2387 31.1465 11.6567 30.1782 11.1562C30.9669 12.702 31.423 14.2536 31.5974 15.4109C31.5974 15.4074 31.5986 15.4138 31.5998 15.4237L31.6021 15.4389C32.925 19.0245 32.2041 22.6708 31.1658 24.899C29.5593 28.3464 25.671 31.8795 19.583 31.7063C13.0056 31.5208 7.21095 26.6414 6.12949 20.2483C5.93234 19.2403 6.12949 18.7288 6.22866 17.9104C6.10791 18.5404 6.06183 18.7235 6.00117 19.8441L6 19.9158C6 27.6563 12.2764 33.9327 20.0181 33.9327C26.9519 33.9327 32.7086 28.8988 33.8368 22.2881L33.9009 21.7474C34.1792 19.3442 33.87 16.8167 32.991 14.7039H32.9898Z",
			fill: "url(#paint1_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9898 14.7039C32.3808 13.2387 31.1465 11.6567 30.1782 11.1562C30.9669 12.702 31.423 14.2536 31.5974 15.4109C31.5974 15.4074 31.5986 15.4138 31.5998 15.4237L31.6021 15.4389C32.925 19.0245 32.2041 22.6708 31.1658 24.899C29.5593 28.3464 25.671 31.8795 19.583 31.7063C13.0056 31.5208 7.21095 26.6414 6.12949 20.2483C5.93234 19.2403 6.12949 18.7288 6.22866 17.9104C6.10791 18.5404 6.06183 18.7235 6.00117 19.8441L6 19.9158C6 27.6563 12.2764 33.9327 20.0181 33.9327C26.9519 33.9327 32.7086 28.8988 33.8368 22.2881L33.9009 21.7474C34.1792 19.3442 33.87 16.8167 32.991 14.7039H32.9898Z",
			fill: "url(#paint2_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.1781 16.351L26.2656 16.4152C25.9138 15.7908 25.4757 15.2192 24.9643 14.7172C20.6063 10.3604 23.8204 5.2699 24.3629 5.01149L24.3687 5.00391C20.8473 7.06591 19.6526 10.8813 19.543 12.7899C19.7063 12.7783 19.8696 12.7648 20.0353 12.7648C22.6631 12.7648 24.9526 14.2097 26.1775 16.3522L26.1781 16.351Z",
			fill: "url(#paint3_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0456 17.2202C20.0222 17.569 18.7914 18.7718 18.3598 18.7718C14.3735 18.7718 13.7266 21.1826 13.7266 21.1826C13.9033 23.2125 15.3167 24.8854 17.0281 25.7703C17.1063 25.8111 17.1856 25.8461 17.2643 25.8829C17.4 25.943 17.5373 25.9992 17.6762 26.0515C18.2632 26.2593 18.878 26.3778 19.5002 26.4032C26.4871 26.731 27.8415 18.0502 22.7988 15.5303C24.0897 15.3057 25.4295 15.8249 26.1785 16.351C24.9535 14.2091 22.664 12.7637 20.0362 12.7637C19.87 12.7637 19.7072 12.7777 19.5439 12.7888C18.1377 12.8855 16.7933 13.4036 15.6859 14.2756C15.8994 14.4564 16.1409 14.6979 16.6484 15.199C17.5992 16.1358 20.0392 17.1064 20.0444 17.2202H20.0456Z",
			fill: "url(#paint4_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0456 17.2202C20.0222 17.569 18.7914 18.7718 18.3598 18.7718C14.3735 18.7718 13.7266 21.1826 13.7266 21.1826C13.9033 23.2125 15.3167 24.8854 17.0281 25.7703C17.1063 25.8111 17.1856 25.8461 17.2643 25.8829C17.4 25.943 17.5373 25.9992 17.6762 26.0515C18.2632 26.2593 18.878 26.3778 19.5002 26.4032C26.4871 26.731 27.8415 18.0502 22.7988 15.5303C24.0897 15.3057 25.4295 15.8249 26.1785 16.351C24.9535 14.2091 22.664 12.7637 20.0362 12.7637C19.87 12.7637 19.7072 12.7777 19.5439 12.7888C18.1377 12.8855 16.7933 13.4036 15.6859 14.2756C15.8994 14.4564 16.1409 14.6979 16.6484 15.199C17.5992 16.1358 20.0392 17.1064 20.0444 17.2202H20.0456Z",
			fill: "url(#paint5_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0312 13.81C15.1289 13.873 15.2257 13.9372 15.3217 14.0025C15.0022 12.8845 14.9887 11.7012 15.2827 10.5762C13.8419 11.2324 12.7219 12.2678 11.9082 13.1836C11.9753 13.1818 14.0081 13.1451 15.0312 13.81Z",
			fill: "url(#paint6_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.12965 20.2478C7.21169 26.6408 13.0057 31.5202 19.5825 31.7063C25.6706 31.879 29.5595 28.3453 31.1659 24.8991C32.2042 22.6708 32.9252 19.0252 31.6022 15.439V15.4378L31.5999 15.4238C31.5987 15.4139 31.5976 15.4075 31.5976 15.411L31.6005 15.4343C32.0981 18.681 30.4455 21.8262 27.8644 23.953L27.8568 23.9705C22.8258 28.067 18.0117 26.4419 17.0364 25.777C16.9679 25.7441 16.8998 25.7102 16.8322 25.6755C13.8993 24.2738 12.6878 21.6016 12.9474 19.3098C10.4712 19.3098 9.6266 17.2216 9.6266 17.2216C9.6266 17.2216 11.8502 15.6361 14.7807 17.0145C17.4949 18.2919 20.0439 17.2216 20.0439 17.221C20.0381 17.1072 17.5987 16.136 16.6479 15.1998C16.1393 14.6982 15.8984 14.4578 15.6843 14.2764C15.5684 14.1785 15.4473 14.087 15.3215 14.0023C15.2253 13.9371 15.1285 13.8729 15.031 13.8098C14.0084 13.1448 11.9744 13.1821 11.9073 13.1839H11.9015C11.3456 12.4798 11.3847 10.1577 11.4162 9.67236C11.4104 9.6432 11.002 9.88411 10.9484 9.92085C10.4579 10.2709 9.9994 10.6636 9.57818 11.0945C9.09897 11.5806 8.66114 12.1058 8.26923 12.6647L8.26865 12.6665V12.6647C7.3672 13.9421 6.72782 15.3854 6.38747 16.9112C6.38164 16.9416 5.88291 19.1185 6.12848 20.2478H6.12965Z",
			fill: "url(#paint7_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.9632 14.718C25.4746 15.2199 25.9127 15.7913 26.2646 16.4155L26.4745 16.5881C29.6536 19.5163 27.9877 23.6578 27.8628 23.953C30.4446 21.8262 32.0965 18.681 31.5989 15.4343C30.0147 11.483 27.3273 9.88939 25.1323 6.42045L24.8022 5.8838C24.747 5.78917 24.6954 5.69246 24.6476 5.5939C24.5565 5.41795 24.4862 5.23198 24.4382 5.03975C24.4386 5.03056 24.4355 5.02157 24.4295 5.01455C24.4236 5.00753 24.4152 5.003 24.4061 5.00184C24.3975 4.99939 24.3885 4.99939 24.3799 5.00184L24.3729 5.00592L24.363 5.01175C23.8205 5.27016 20.6064 10.3607 24.9638 14.718H24.9632Z",
			fill: "url(#paint8_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.4752 16.5872C26.4081 16.5264 26.338 16.469 26.2652 16.4151L26.1777 16.3509C25.4294 15.826 24.0895 15.3056 22.798 15.5302C27.8402 18.0513 26.4863 26.7315 19.4994 26.4031C18.8772 26.3777 18.2624 26.2592 17.6754 26.0514C17.5366 25.9991 17.3992 25.9429 17.2636 25.8828C17.1839 25.8472 17.1051 25.8097 17.0273 25.7702L17.0367 25.776C18.0108 26.441 22.8255 28.0655 27.8571 23.9695L27.8647 23.952C27.9889 23.6569 29.6543 19.5154 26.4764 16.5872H26.4752Z",
			fill: "url(#paint9_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7253 21.1834C13.7253 21.1834 14.3728 18.7726 18.3585 18.7726C18.7902 18.7726 20.021 17.5698 20.0443 17.221C20.0676 16.8721 17.4952 18.2919 14.7811 17.0145C11.8505 15.6361 9.62695 17.221 9.62695 17.221C9.62695 17.221 10.4716 19.3092 12.9477 19.3092C12.6882 21.6016 13.8997 24.2732 16.8326 25.6749C16.8985 25.7058 16.9598 25.7402 17.0274 25.7705C15.3154 24.8857 13.902 23.2133 13.7259 21.1828L13.7253 21.1834Z",
			fill: "url(#paint10_radial_6199_8807)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9898 14.7034C32.3808 13.2382 31.1465 11.6562 30.1782 11.1558C30.9669 12.7015 31.423 14.2531 31.5974 15.4104L31.6003 15.4337C30.0149 11.483 27.3276 9.88939 25.1326 6.42045L24.8024 5.8838C24.7472 5.78917 24.6957 5.69246 24.6479 5.5939C24.5568 5.41795 24.4865 5.23198 24.4385 5.03975C24.4388 5.03056 24.4357 5.02157 24.4298 5.01455C24.4238 5.00753 24.4155 5.003 24.4064 5.00184C24.3978 4.99939 24.3887 4.99939 24.3801 5.00184L24.3731 5.00592L24.3632 5.01175L24.369 5.00359C20.8476 7.06617 19.653 10.881 19.5427 12.7908C19.7061 12.7791 19.8694 12.7657 20.0356 12.7657C22.6634 12.7657 24.9529 14.2105 26.1779 16.3519C25.4289 15.8269 24.0896 15.3066 22.7976 15.5312C27.8397 18.0522 26.4859 26.7325 19.499 26.4041C18.8768 26.3787 18.262 26.2601 17.675 26.0523C17.5361 26 17.3988 25.9438 17.2631 25.8837C17.1835 25.8482 17.1047 25.8106 17.0269 25.7712L17.0368 25.777C16.9683 25.7441 16.9003 25.7103 16.8327 25.6755C16.898 25.7064 16.9598 25.7408 17.0269 25.7712C15.3149 24.8863 13.9015 23.2139 13.7254 21.1834C13.7254 21.1834 14.3717 18.7726 18.358 18.7726C18.7897 18.7726 20.0205 17.5698 20.0438 17.221C20.038 17.1073 17.5997 16.1361 16.6478 15.1998C16.1403 14.6982 15.8982 14.4579 15.6853 14.2765C15.5692 14.1785 15.4479 14.087 15.3219 14.0023C15.0025 12.8845 14.989 11.7014 15.2828 10.5765C13.842 11.2322 12.7221 12.2681 11.9084 13.1839H11.9025C11.3466 12.4799 11.3857 10.1583 11.4172 9.6724C11.4114 9.64323 11.0031 9.88414 10.9494 9.92089C10.4589 10.2709 10.0004 10.6636 9.57919 11.0945C9.10019 11.5807 8.66255 12.1059 8.27083 12.6648L8.27025 12.6665V12.6648C7.36879 13.9421 6.72942 15.3854 6.38907 16.9113L6.3704 17.0046C6.31085 17.2981 6.25698 17.5927 6.20883 17.8883C6.20766 17.8988 6.20999 17.8784 6.20883 17.8883C6.10051 18.5355 6.03136 19.1886 6.00175 19.8442L6 19.9153C6 27.6558 12.2764 33.9322 20.0181 33.9322C26.9519 33.9322 32.7086 28.8983 33.8368 22.2876L33.9009 21.7469C34.1792 19.3437 33.87 16.8162 32.991 14.7034H32.9898ZM31.5992 15.4232L31.6015 15.4384V15.4372L31.5992 15.4232Z",
			fill: "url(#paint11_linear_6199_8807)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6199_8807",
				x1: 1258150,
				y1: 230957,
				x2: 98921.4,
				y2: 1349230,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .05,
						stopColor: "#FFF44F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .37,
						stopColor: "#FF980E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .53,
						stopColor: "#FF3647"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7,
						stopColor: "#E31587"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(1.00825e+06 -151304) scale(1.47661e+06 1.50143e+06)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .13,
						stopColor: "#FFBD4F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .28,
						stopColor: "#FF980E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .47,
						stopColor: "#FF3750"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .78,
						stopColor: "#EB0878"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .86,
						stopColor: "#E50080"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(579401 469207) scale(1.51352e+06 1.50143e+06)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .3,
						stopColor: "#960E18"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .35,
						stopColor: "#B11927",
						stopOpacity: .74
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .43,
						stopColor: "#DB293D",
						stopOpacity: .34
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#F5334B",
						stopOpacity: .1
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .53,
						stopColor: "#FF3750",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(166204 -70516.8) scale(484704 822754)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .13,
					stopColor: "#FFF44F"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .53,
					stopColor: "#FF980E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(145968 773978) scale(641275 702901)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .35,
						stopColor: "#3A8EE6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .67,
						stopColor: "#9059FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#C139E6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint5_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(300129 231970) scale(340517 414712)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .21,
					stopColor: "#9059FF",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .97,
					stopColor: "#6E008B",
					stopOpacity: .6
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint6_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(369186 -176447) scale(509811 511727)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .1,
					stopColor: "#FFE226"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .79,
					stopColor: "#FF7139"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint7_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(1.13599e+06 -465417) scale(2.43424e+06 2.04334e+06)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .11,
						stopColor: "#FFF44F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .46,
						stopColor: "#FF980E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#FF3647"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9,
						stopColor: "#E31587"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint8_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(188341 25875.6) rotate(77.3945) scale(772151 3.3408e+06)",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#FFF44F" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3,
						stopColor: "#FF980E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .57,
						stopColor: "#FF3647"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .74,
						stopColor: "#E31587"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint9_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(110819 -244736) scale(1.39763e+06 1.37291e+06)",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .14,
						stopColor: "#FFF44F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48,
						stopColor: "#FF980E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .66,
						stopColor: "#FF3647"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .9,
						stopColor: "#E31587"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint10_radial_6199_8807",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(854656 -214616) scale(1.67979e+06 1.50271e+06)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#FFF44F"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#FF980E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint11_linear_6199_8807",
				x1: 1153610,
				y1: 208607,
				x2: 226629,
				y2: 1221470,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .17,
					stopColor: "#FFF44F",
					stopOpacity: .8
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#FFF44F",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgAssetFirefoxIconOl;
